(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Filters", [], factory);
	else if(typeof exports === 'object')
		exports["Filters"] = factory();
	else
		root["Filters"] = factory();
})(this, function() {
return 